import { useCallback, useEffect, useState } from "react";
import { IObrigacaoAcessorias } from "../../interfaces/IObrigacaoAcessorias";
import { Modal } from 'react-bootstrap-v5';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import ObrigacaoAcessoriasService from "../../services/ObrigacaoAcessoriasService";
import clsx from "clsx";
import { ICoordenadas } from "../../interfaces/ICoordenadas";

function ObrigacaoAcessoriasModal({ toggleModal, show, obrigacao, title }: { toggleModal: (loadItens?: boolean) => void, show: boolean, obrigacao: IObrigacaoAcessorias, title: string }) {
    
    const [coordenadas, setCoordenadas] = useState<ICoordenadas[]>([]);

    const coordenadasSchema = Yup.object().shape({
        nome: Yup.string().max(50, 'Maximo 150 caracteres').required('Nome é obrigatório'),
        versao: Yup.string().max(50, 'Maximo 50 caracteres').required('Versão é obrigatório'),
        bloco: Yup.string().max(50, 'Maximo 50 caracteres').required('Bloco é obrigatório'),
        campo: Yup.string().max(50, 'Maximo 50 caracteres').required('Campo é obrigatório'),
        posicaoTXT: Yup.string().max(50, 'Maximo 50 caracteres'),
        tamanho: Yup.string().max(50, 'Maximo 50 caracteres'),
        registro: Yup.string().max(50, 'Maximo 50 caracteres'),
    })

    const obrigacoesSchema = Yup.object().shape({
        descricao: Yup.string().max(50, 'Maximo 50 caracteres').required('Descrição é obrigatório'),
        observacao: Yup.string().max(250, 'Maximo 250 caracteres'),
        tipo: Yup.string(),
        ordemClassificacao: Yup.string().max(50, 'Maximo 50 caracteres').required('Ordem de Classificação é obrigatório'),
    })
    const formInitialValues: IObrigacaoAcessorias = {
        id: 0,
        descricao: '',
        observacao: '',
        ordemClassificacao: '',
        tipo: '',
        coordenadas: []
    };

    const coordenadasInitialValue: ICoordenadas = {
        id: 0,
        bloco: '',
        campo: '',
        nome: '',
        obrigacaoAcessoriaID: 0,
        posicaoTXT: '',
        registro: '',
        tamanho: '',
        versao: ''
    }
    const formik = useFormik({
        initialValues: formInitialValues,
        validationSchema: obrigacoesSchema,
        onSubmit: async (values, { setSubmitting }) => {
            values.coordenadas = coordenadas;
            if (!values.id || values.id === 0) {
                await ObrigacaoAcessoriasService.criar(values, () => toggleModal(true), 'Obrigação Acessória foi adicionada com sucesso');
            } else {
                await ObrigacaoAcessoriasService.atualizar(values, () => toggleModal(true), 'Obrigação Acessória foi editado com sucesso');
            }

            setSubmitting(false);
        }
    })

    const formikCoordenadas = useFormik({
        initialValues: coordenadasInitialValue,
        validationSchema: coordenadasSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setCoordenadas((oldValues) => {
                const old = oldValues;
                old.push(values);
                return old;
            });
            formikCoordenadas.resetForm();
        }
    });

    useEffect(() => {
        formik.setValues(obrigacao);
        setCoordenadas(obrigacao.coordenadas || []);

        !obrigacao.descricao && formik.setFieldTouched('descricao', false);
        !obrigacao.observacao && formik.setFieldTouched('observacao', false);
        !obrigacao.ordemClassificacao && formik.setFieldTouched('ordemClassificacao', false);
        !obrigacao.tipo && formik.setFieldTouched('tipo', false);

        // eslint-disable-next-line
    }, [obrigacao]);

    const removerCoordenadas = useCallback((index: number) => {
        setCoordenadas((oldValues) => {
            const old = oldValues;
            old.splice(index, 1);
            return old;
        });

        console.log(coordenadas);
    }, []);

    const ListCoordenadas = useCallback(() => (
        <div className="row">
            <div className="col-md-12">
                <table className="table mt-5">
                    <thead>
                        <th scope="col">Nome</th>
                        <th scope="col">Versão</th>
                        <th scope="col">Bloco</th>
                        <th scope="col">Campo</th>
                        <th scope="col">Registro</th>
                        <th scope="col">Posição TXT</th>
                        <th scope="col">Tamanho</th>
                    </thead>
                    <tbody>
                        {coordenadas.map((item, index) => (
                            <tr key={`${item.versao}-${index}`}>
                                <td>{item.nome}</td>
                                <td>{item.versao}</td>
                                <td>{item.bloco}</td>
                                <td>{item.campo}</td>
                                <td>{item.registro}</td>
                                <td>{item.posicaoTXT}</td>
                                <td>{item.tamanho}</td>
                                <td>
                                    <button type="button" onClick={() => removerCoordenadas(index)} className="btn btn-danger">
                                    <i className="fa fa-trash text-white rotate-180"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    ), [coordenadas, removerCoordenadas]);
    
    return <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title titulo-modal">{title}</h5>
                <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                    <i onClick={() => toggleModal()} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                </div>
            </div>
            <div className="modal-body">
            <h3>Dados </h3>
                <form className="row g-3">
                    <div className="col-md-9">
                        <label htmlFor="form-obrigacao-descricao" className="form-label required">Obrigação Acessória</label>
                        <input {...formik.getFieldProps('descricao')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.descricao && formik.errors.descricao
                            },
                            {
                                'is-valid': formik.touched.descricao && !formik.errors.descricao
                            }
                        )} id="form-obrigacao-descricao" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-tipo" className="form-label required">Tipo</label>
                        <input {...formik.getFieldProps('tipo')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.tipo && formik.errors.tipo
                            },
                            {
                                'is-valid': formik.touched.tipo && !formik.errors.tipo
                            }
                        )} id="form-obrigacao-tipo" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-ordemClassificacao" className="form-label required mt-5">Ordem de Classificação</label>
                        <input {...formik.getFieldProps('ordemClassificacao')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.ordemClassificacao && formik.errors.ordemClassificacao
                            },
                            {
                                'is-valid': formik.touched.ordemClassificacao && !formik.errors.ordemClassificacao
                            }
                        )} id="form-obrigacao-ordemClassificacao" />
                    </div>
                    <div className="col-md-9">
                        <label htmlFor="form-obrigacao-observacao" className="form-label mt-5">Observação</label>
                        <input {...formik.getFieldProps('observacao')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.observacao && formik.errors.observacao
                            },
                            {
                                'is-valid': formik.touched.observacao && !formik.errors.observacao
                            }
                        )} id="form-obrigacao-observacao" />
                    </div>
                </form>
                <h3 className="mt-10">Coordenadas </h3>
                <form className="row">
                    <div className="col-md-3">
                        <label htmlFor="form-coordenadas-nome" className="form-label required mt-5">Nome</label>
                        <input {...formikCoordenadas.getFieldProps('nome')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formikCoordenadas.touched.nome && formikCoordenadas.errors.nome
                            },
                            {
                                'is-valid': formikCoordenadas.touched.nome && !formikCoordenadas.errors.nome
                            }
                        )} id="form-coordenadas-nome" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-coordenadas-versao" className="form-label required mt-5">Versão</label>
                        <input {...formikCoordenadas.getFieldProps('versao')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formikCoordenadas.touched.versao && formikCoordenadas.errors.versao
                            },
                            {
                                'is-valid': formikCoordenadas.touched.versao && !formikCoordenadas.errors.versao
                            }
                        )} id="form-coordenadas-versao" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-coordenadas-bloco" className="form-label required mt-5">Bloco</label>
                        <input {...formikCoordenadas.getFieldProps('bloco')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formikCoordenadas.touched.bloco && formikCoordenadas.errors.bloco
                            },
                            {
                                'is-valid': formikCoordenadas.touched.bloco && !formikCoordenadas.errors.bloco
                            }
                        )} id="form-coordenadas-bloco" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-coordenadas-campo" className="form-label required mt-5">Campo</label>
                        <input {...formikCoordenadas.getFieldProps('campo')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formikCoordenadas.touched.campo && formikCoordenadas.errors.campo
                            },
                            {
                                'is-valid': formikCoordenadas.touched.campo && !formikCoordenadas.errors.campo
                            }
                        )} id="form-coordenadas-campo" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-coordenadas-registro" className="form-label required mt-5">Registro</label>
                        <input {...formikCoordenadas.getFieldProps('registro')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formikCoordenadas.touched.registro && formikCoordenadas.errors.registro
                            },
                            {
                                'is-valid': formikCoordenadas.touched.registro && !formikCoordenadas.errors.registro
                            }
                        )} id="form-coordenadas-registro" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-coordenadas-posicaoTXT" className="form-label required mt-5">Posição TXT</label>
                        <input {...formikCoordenadas.getFieldProps('posicaoTXT')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formikCoordenadas.touched.posicaoTXT && formikCoordenadas.errors.posicaoTXT
                            },
                            {
                                'is-valid': formikCoordenadas.touched.posicaoTXT && !formikCoordenadas.errors.posicaoTXT
                            }
                        )} id="form-coordenadas-posicaoTXT" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-coordenadas-tamanho" className="form-label required mt-5">Tamanho</label>
                        <input {...formikCoordenadas.getFieldProps('tamanho')} placeholder="Digite algo" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formikCoordenadas.touched.tamanho && formikCoordenadas.errors.tamanho
                            },
                            {
                                'is-valid': formikCoordenadas.touched.tamanho && !formikCoordenadas.errors.tamanho
                            }
                        )} id="form-coordenadas-tamanho" />
                    </div>
                    <div className="col-md-3" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <button type="button" onClick={() => formikCoordenadas.submitForm()} className="btn btn-modal-cancelar mt-13">Inserir +</button>
                    </div>
                </form>
                <ListCoordenadas />
            </div>
            <div className="modal-footer" style={{ margin: '0 auto' }}>
                <button disabled={formik.isSubmitting} onClick={() => toggleModal()} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
                <button disabled={formik.isSubmitting} onClick={() => formik.submitForm()} type="button" className="btn btn-primario ms-5">
                    {
                        !formik.isSubmitting && (obrigacao?.id ? 'EDITAR' : 'ADICIONAR')
                    }
                    {
                        formik.isSubmitting &&
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                Salvando...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'/>
                            </span>
                    }
                </button>
            </div>
        </div>
    </Modal>
}

export default ObrigacaoAcessoriasModal;